<div>
    <form id="reporting-set-data-field">
        <div class="input-field">
            <label for="field-type-dropdown" id="comparison-type-label" cvLocalizedText langSection="ETL_Reporting_Set"
                langKey="Comparison_Type">COMPARISON TYPE </label><span class="comparison-required">
                * </span>
            <cxone-singleselect-dropdown id="comparison-type-dropdown" [label]="'label'" [isRequired]="true"
                [primaryKey]="'label'" [options]="comparisonOptions" [showFooter]="false" [search]="false"
                [(ngModel)]="comparisonForm.comparisonType" (ngModelChange)="comparisonTypeChange()"
                [ngModelOptions]="{standalone: true}" [sortKey]="'id'">
            </cxone-singleselect-dropdown>
        </div>

        <div class="input-field">
            <label for="field-one" id="field-name-label" cvLocalizedText langSection="ETL_Reporting_Set"
                langKey="Add_Field_One">
                ADD FIELD 1
            </label> <span class="field-required"> * </span>
            <div class="row list-item"
                *ngIf="comparisonForm.hasOwnProperty('field1') && comparisonForm?.field1?.length > 0">
                <ng-container *ngTemplateOutlet="addedList; context: { source: {fieldType: 'field1'} }"> </ng-container>
            </div>
            <div class="row list-item"
                *ngIf="!comparisonForm.hasOwnProperty('field1') || comparisonForm?.field1?.length === 0">
                <ng-container *ngTemplateOutlet="emptyList; context: { source: {fieldType: 'field1'} }"> </ng-container>
            </div>
        </div>

        <div class="input-field" *ngIf="!singleFieldTypes.includes(comparisonForm.comparisonType.value)">
            <label for="field-two" id="field-name-label" cvLocalizedText langSection="ETL_Reporting_Set"
                langKey="Add_Field_Two">
                ADD FIELD 2
            </label> <span class="field-required"> * </span>
            <div class="row list-item"
                *ngIf="comparisonForm.hasOwnProperty('field2') && comparisonForm?.field2?.length > 0">
                <ng-container *ngTemplateOutlet="addedList; context: { source: {fieldType: 'field2'} }"> </ng-container>
            </div>
            <div class="row list-item"
                *ngIf="!comparisonForm.hasOwnProperty('field2') || comparisonForm?.field2?.length === 0">
                <ng-container *ngTemplateOutlet="emptyList; context: { source: {fieldType: 'field2'} }"> </ng-container>
            </div>
        </div>
    </form>
</div>
<ng-template #addedList let-source="source">
    <div class="col-10 add-field-box">
        <p class="row ellipsis-text" title="{{comparisonForm[source?.fieldType][0]?.name}}">
            {{comparisonForm[source?.fieldType][0]?.name}}</p>
    </div>
    <div class="col-2 cursor-pointer icon-container">
        <svg class="icon edit-icon" (click)="editInput(comparisonForm[source?.fieldType][0])">
            <use href="../App_Themes/CXone/icons/edit.svg#edit"></use>
        </svg>
    </div>
</ng-template>
<ng-template #emptyList let-source="source">
    <div class="col-10 add-field-box">
        <p class="row add-field-empty-box" cvLocalizedText langSection="ETL_Reporting_Set"
            langKey="Input_Field_Placeholder">Add input</p>
    </div>
    <div class="col-2 cursor-pointer icon-container" [class.disable-div]="comparisonForm.comparisonType == ''">
        <svg class="icon add-icon icon-14" (click)="fieldAddClick(source?.fieldType)">
            <use href="../App_Themes/CXone/icons/add.svg#add"></use>
        </svg>
    </div>
</ng-template>